import "@/global/theme/global.css";
import * as React from "react";
import { AppProps } from "next/app";

import "react-toastify/dist/ReactToastify.css";
import "react-virtualized/styles.css";

import { BaseAppProvider } from "@/global/context/AppProviderRoot";
import { ToastContainer } from "react-toastify";

export default function MyApp(props: AppProps) {
  const { Component, pageProps } = props;

  return (
    <>
      <ToastContainer position="bottom-left" />
      <BaseAppProvider>
        <Component {...pageProps} />
      </BaseAppProvider>
    </>
  );
}
